import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Heading, Text, Flex, Image, Spacer, ButtonGroup, Button, useDisclosure, Circle, Link } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import BoxAccordionItem from "components/accordion/BoxAccordionItem";
import moment from "moment";
import ToolbarLessonGroup from "./toolbar-lesson-group";
import { WarningIcon } from "@chakra-ui/icons";
import { BsEye } from "react-icons/bs";

interface ProgramLessonProps {
    program: any
    onRefreshData: any
};

const ProgramListLesson: React.FC<ProgramLessonProps> = ({ program, onRefreshData }) => {
    var navigate = useNavigate();
    const { isOpen: isShowEditLessonGroupDialog, onOpen: onShowEditLessonGroupDialog, onClose: onCloseEditLessonGroupDialog } = useDisclosure();

    return (
        <Accordion defaultIndex={[0, 1, 2]} colorScheme={"teal"} allowMultiple color='whiteAlpha.900'>
            {
                program.lessonGroups.length > 0 &&
                program.lessonGroups.map((lessonGroup: any) => {
                    return (
                        <AccordionItem mt={5} key={lessonGroup.id}>
                            <h2>
                                <AccordionButton>
                                    <Box flex='1' textAlign='left'>
                                        <Flex>
                                            <Heading fontSize={{ base: 'md', md: 'lg' }} fontWeight={"semibold"}>{lessonGroup.sequence}. {lessonGroup.title}</Heading>
                                            <Spacer />
                                            <ToolbarLessonGroup program={program} lessonGroup={lessonGroup} />
                                        </Flex>
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>

                            <AccordionPanel pb={4}>
                                {
                                    lessonGroup.lessons.map((lesson: any) => {
                                        return (
                                            <BoxAccordionItem p={{ base: 2, md: 4 }} key={lesson.id} cursor={lesson.isLocked ? 'disabled' : 'pointer'} variant={'lessonAccordionItem'}
                                                onClick={() => navigate(`/programs/${program.id}/lessongroups/${lessonGroup.id}/lessons/${lesson.id}`)}>
                                                <Link href={`/programs/${program.id}/lessongroups/${lessonGroup.id}/lessons/${lesson.id}`}>
                                                    <Flex my={0}>
                                                        <Image
                                                            rounded={10}
                                                            w={'75px'}
                                                            h={'50px'}
                                                            objectFit='cover'
                                                            src={lesson.posterUrl}
                                                            alt={lesson.title}
                                                        />
                                                        <Box ml={{ base: 3, md: 5 }} verticalAlign={'middle'}>
                                                            <Heading fontSize={{ base: 'sm', md: 'md' }} fontWeight={'semibold'}>{lesson.sequence}. {lesson.title}</Heading>
                                                            <Text fontSize={'xs'} fontWeight={'normal'}>{moment.duration(lesson.duration).asMinutes().toPrecision(2)} mins</Text>
                                                        </Box>
                                                        <Spacer />
                                                        <Flex alignItems={"center"}>
                                                            {
                                                                !lesson.isActive && <WarningIcon color={'red.200'} fontSize={'1.5em'} mr={4} />
                                                            }
                                                            {
                                                                lesson.isAllowForPublic && <BsEye color={'red.200'} fontSize={'1.5em'} />
                                                            }
                                                            <FiChevronRight size={'1.5em'} />
                                                        </Flex>
                                                    </Flex>
                                                </Link>
                                            </BoxAccordionItem>
                                        )
                                    })
                                }
                            </AccordionPanel>
                        </AccordionItem>
                    );
                })
            }
        </Accordion>
    );
};

export default ProgramListLesson;